import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const LogoWall = () => {
  const containers = document.querySelectorAll(".logo-wall");
  if (containers.length < 1) {
    return;
  }

  const applyAnimations = () => {
    if (window.innerWidth >= 1024) {
      containers.forEach((container) => {
        const headline = container.querySelectorAll(".logo-wall__headline");
        if (headline.length) {
          gsap.to(headline, {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.inOut",
            scrollTrigger: {
              trigger: container,
              start: "top 80%",
              once: true,
              fastScrollEnd: true,
            },
          });
        }
        const logos = container.querySelectorAll(".logo");
        gsap.to(logos, {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: "power3.inOut",
          stagger: 0.15,
          scrollTrigger: {
            trigger: container,
            start: "top 80%",
            once: true,
            fastScrollEnd: true,
          },
        });
      });
    }
    if (window.innerWidth < 1024) {
      containers.forEach((container) => {
        const headline = container.querySelectorAll(".logo-wall__headline");
        const logos = container.querySelectorAll(".logo");
        if (headline.length) {
          gsap.to(headline, {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.inOut",
            scrollTrigger: {
              trigger: container,
              start: "top 80%",
              once: true,
              fastScrollEnd: true,
            },
          });
        }
        gsap.to(logos, {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: "power3.inOut",
          stagger: 0.15,
          scrollTrigger: {
            trigger: container,
            start: "top 80%",
            once: true,
            fastScrollEnd: true,
          },
        });
        // logos.forEach((logo) => {
        //   logo.style.opacity = 1;
        //   logo.style.transform = 'translateY(0)';
        // });
      });
    }
  };
  applyAnimations();

  window.addEventListener("resize", () => {
    if (window.innerWidth >= 1024) {
      applyAnimations();
    }
  });
};

export default LogoWall;
